var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "report-tab-layout",
    {
      scopedSlots: _vm._u([
        {
          key: "card-footer",
          fn: function () {
            return [
              _c("report-toolbar", {
                attrs: {
                  "set-default-props": _vm.settingDefault,
                  "report-props": Object.assign({}, _vm.runningReport, {
                    disabled: _vm.$v.$invalid,
                  }),
                },
                on: {
                  "clear-selection": _vm.handleClearSelection,
                  "reset-to-default": _vm.handleResetToDefault,
                  "set-default": _vm.handleSetDefault,
                  "run-report": _vm.handleRunReport,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.loading
        ? _c("lender-transactions-container-loader")
        : _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("application-reports.level")) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-level", {
                            attrs: {
                              "selected-level":
                                _vm.localLenderTransactionData.level,
                            },
                            on: {
                              "update:selectedLevel": function ($event) {
                                return _vm.$set(
                                  _vm.localLenderTransactionData,
                                  "level",
                                  $event
                                )
                              },
                              "update:selected-level": function ($event) {
                                return _vm.$set(
                                  _vm.localLenderTransactionData,
                                  "level",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showAgentsSelect
                        ? _c(
                            "b-col",
                            {
                              staticClass: "mb-3",
                              attrs: { cols: "12", sm: "6" },
                            },
                            [
                              _c(
                                "h6",
                                {
                                  staticClass:
                                    "bold mb-1 form-title font-sm text-capitalize",
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$tc("global.doorr.agent", 1)) +
                                      "\n            "
                                  ),
                                  _c("input-required-indicator"),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("agents-select", {
                                    attrs: {
                                      id: "select-agents-reports",
                                      "default-value":
                                        _vm.localLenderTransactionData.agent,
                                      value:
                                        _vm.localLenderTransactionData.agent,
                                      "select-options": _vm.agentsOptions,
                                      "space-classes":
                                        "form-group-material form-group-material-no-label",
                                      label: "",
                                      "has-checkboxes": "",
                                      "close-on-select-all": "",
                                      "extra-select-data": [
                                        _vm.allAgentsOption,
                                      ],
                                    },
                                    on: { change: _vm.handleSelectAgentChange },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("application-reports.format")) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-format", {
                            attrs: {
                              "selected-format":
                                _vm.localLenderTransactionData.format,
                              action: _vm.action,
                            },
                            on: {
                              "update:selectedFormat": function ($event) {
                                return _vm.$set(
                                  _vm.localLenderTransactionData,
                                  "format",
                                  $event
                                )
                              },
                              "update:selected-format": function ($event) {
                                return _vm.$set(
                                  _vm.localLenderTransactionData,
                                  "format",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "bold form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("application-reports.lender")) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-lender", {
                            attrs: {
                              "selected-lender":
                                _vm.localLenderTransactionData.lender,
                              action: _vm.action,
                              clearable: "",
                              "default-value":
                                _vm.localLenderTransactionData.lender,
                              multiple: "",
                            },
                            on: {
                              "update:selectedLender": function ($event) {
                                return _vm.$set(
                                  _vm.localLenderTransactionData,
                                  "lender",
                                  $event
                                )
                              },
                              "update:selected-lender": function ($event) {
                                return _vm.$set(
                                  _vm.localLenderTransactionData,
                                  "lender",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-reports.applicationStatus"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-application-status", {
                            attrs: {
                              multiple: "",
                              action: _vm.action,
                              clearable: "",
                              "status-to-exclude": ["pending"],
                              "selected-application-status":
                                _vm.localLenderTransactionData
                                  .applicationStatus,
                            },
                            on: {
                              "update:selectedApplicationStatus": function (
                                $event
                              ) {
                                return _vm.$set(
                                  _vm.localLenderTransactionData,
                                  "applicationStatus",
                                  $event
                                )
                              },
                              "update:selected-application-status": function (
                                $event
                              ) {
                                return _vm.$set(
                                  _vm.localLenderTransactionData,
                                  "applicationStatus",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-reports.applications-summary.dateType"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "material-input",
                            {
                              staticClass: "no-border",
                              attrs: { id: "select-date-type", "no-label": "" },
                              model: {
                                value: _vm.localLenderTransactionData.dateType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localLenderTransactionData,
                                    "dateType",
                                    $$v
                                  )
                                },
                                expression:
                                  "localLenderTransactionData.dateType",
                              },
                            },
                            [
                              _c("v-select-field", {
                                staticClass: "search-input w-100 simple-dd",
                                attrs: {
                                  options: _vm.dateTypeOptions,
                                  placeholder: _vm.$t(
                                    "global.actions.chooseOption"
                                  ),
                                  value:
                                    _vm.localLenderTransactionData.dateType,
                                  clearable: false,
                                  label: "text",
                                  "default-value":
                                    _vm.localLenderTransactionData.dateType,
                                  action: _vm.action,
                                },
                                on: {
                                  "option:selected": function ($event) {
                                    _vm.localLenderTransactionData.dateType =
                                      $event.id
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "application-reports.dateFrom"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                      _c("input-required-indicator"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    [
                                      _c("date-section", {
                                        attrs: {
                                          id: "application-summary-date-from",
                                          "maturity-date": "",
                                          placeholder: "YYYY-MM-DD",
                                          "max-date":
                                            _vm.localLenderTransactionData
                                              .dateTo,
                                        },
                                        model: {
                                          value:
                                            _vm.localLenderTransactionData
                                              .dateFrom,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.localLenderTransactionData,
                                              "dateFrom",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "localLenderTransactionData.dateFrom",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("application-reports.dateTo")
                                          ) +
                                          "\n                "
                                      ),
                                      _c("input-required-indicator"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    [
                                      _c("date-section", {
                                        attrs: {
                                          id: "application-summary-date-to",
                                          "maturity-date": "",
                                          placeholder: "YYYY-MM-DD",
                                          "min-date":
                                            _vm.localLenderTransactionData
                                              .dateFrom,
                                        },
                                        model: {
                                          value:
                                            _vm.localLenderTransactionData
                                              .dateTo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.localLenderTransactionData,
                                              "dateTo",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "localLenderTransactionData.dateTo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "bold form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("application-reports.groupBy")
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "material-input",
                            {
                              staticClass: "no-border",
                              attrs: { id: "select-group-by", "no-label": "" },
                              model: {
                                value: _vm.localLenderTransactionData.groupBy,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localLenderTransactionData,
                                    "groupBy",
                                    $$v
                                  )
                                },
                                expression:
                                  "localLenderTransactionData.groupBy",
                              },
                            },
                            [
                              _c("v-select-field", {
                                staticClass: "search-input w-100 simple-dd",
                                attrs: {
                                  options: _vm.groupByOptions,
                                  placeholder: _vm.$t(
                                    "global.actions.chooseOption"
                                  ),
                                  value: _vm.groupBySelectOptions,
                                  clearable: false,
                                  label: "text",
                                  "default-value":
                                    _vm.localLenderTransactionData.groupBy,
                                  action: _vm.action,
                                },
                                on: {
                                  "option:selected": _vm.handleChangeGroupBy,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { sm: "6", cols: "12" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "application-reports.applications-summary.firstSortBy"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                      _c("input-required-indicator"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "material-input",
                                    {
                                      staticClass: "no-border",
                                      attrs: {
                                        id: "select-sort-by-1",
                                        "no-label": "",
                                      },
                                      model: {
                                        value:
                                          _vm.localLenderTransactionData
                                            .sortBy[0],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.localLenderTransactionData
                                              .sortBy,
                                            0,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "localLenderTransactionData.sortBy[0]",
                                      },
                                    },
                                    [
                                      _c("v-select-field", {
                                        staticClass:
                                          "search-input w-100 simple-dd",
                                        attrs: {
                                          options: _vm.primaryOptions,
                                          placeholder: _vm.$t(
                                            "global.actions.chooseOption"
                                          ),
                                          value:
                                            _vm.localLenderTransactionData
                                              .sortBy[0],
                                          clearable: false,
                                          label: "text",
                                          scenario: "reports",
                                          "default-value":
                                            _vm.localLenderTransactionData
                                              .sortBy[0],
                                          action: _vm.action,
                                        },
                                        on: {
                                          "option:selected": function (value) {
                                            return _vm.handleChangeSortBy(
                                              value,
                                              0
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { sm: "6", cols: "12" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "application-reports.applications-summary.secondSortBy"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                      _c("input-required-indicator"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "material-input",
                                    {
                                      staticClass: "no-border",
                                      attrs: {
                                        id: "select-sort-by-2",
                                        "no-label": "",
                                      },
                                      model: {
                                        value:
                                          _vm.localLenderTransactionData
                                            .sortBy[1],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.localLenderTransactionData
                                              .sortBy,
                                            1,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "localLenderTransactionData.sortBy[1]",
                                      },
                                    },
                                    [
                                      _c("v-select-field", {
                                        staticClass:
                                          "search-input w-100 simple-dd",
                                        attrs: {
                                          options: _vm.secondaryOptions,
                                          placeholder: _vm.$t(
                                            "global.actions.chooseOption"
                                          ),
                                          value:
                                            _vm.localLenderTransactionData
                                              .sortBy[1],
                                          clearable: false,
                                          label: "text",
                                          scenario: "reports",
                                          "default-value":
                                            _vm.localLenderTransactionData
                                              .sortBy[1],
                                          action: _vm.action,
                                        },
                                        on: {
                                          "option:selected": function (value) {
                                            return _vm.handleChangeSortBy(
                                              value,
                                              1
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  value: {
                                    title: _vm.$t(
                                      "application-reports.lender-transactions.airMessage"
                                    ),
                                  },
                                  expression:
                                    "{\n              title: $t('application-reports.lender-transactions.airMessage')\n            }",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticClass: "d-inline-block",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "clickable text-capitalize mr-2",
                                  attrs: { for: "air-check" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "application-reports.firm-statistics.annualInformationReturn"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-jelly p-smooth p-curve",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.localLenderTransactionData
                                            .filterForAIR,
                                        expression:
                                          "localLenderTransactionData.filterForAIR",
                                      },
                                    ],
                                    staticClass: "checkbox",
                                    attrs: {
                                      id: "air-check",
                                      type: "checkbox",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.localLenderTransactionData
                                          .filterForAIR
                                      )
                                        ? _vm._i(
                                            _vm.localLenderTransactionData
                                              .filterForAIR,
                                            null
                                          ) > -1
                                        : _vm.localLenderTransactionData
                                            .filterForAIR,
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$a =
                                              _vm.localLenderTransactionData
                                                .filterForAIR,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.localLenderTransactionData,
                                                  "filterForAIR",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.localLenderTransactionData,
                                                  "filterForAIR",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.localLenderTransactionData,
                                              "filterForAIR",
                                              $$c
                                            )
                                          }
                                        },
                                        _vm.handleChangeAIR,
                                      ],
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "state p-success" },
                                    [
                                      _c("i", {
                                        staticClass: "icon fa fa-check",
                                      }),
                                      _vm._v(" "),
                                      _c("label", [
                                        _c(
                                          "span",
                                          { staticStyle: { display: "none" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "application-reports.firm-statistics.annualInformationReturn"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }